import _ from 'static/script/libs/underscore';
import { STORAGE_KEYS } from 'tradera-constants/storage';
import StorageService from 'static/script/app/data/storage-service';

let ItemsInViewportStorage = function() {
    this.maxNoOfStorages = 5;
    this.maxNoOfItems = 200;
    this.timeToLive = 60 * 60 * 1000;
    this._storage = new StorageService(STORAGE_KEYS.ITEMS_IN_VIEWPORT);

    this.SENT = 'SENT';

    this._storage.removeExpired();
    this._removeIfToManyStorages();
};

ItemsInViewportStorage.prototype._removeIfToManyStorages = function() {
    let storageItemsOrderedByExpires = this._storage.fetch().orderByExpire();
    if (storageItemsOrderedByExpires.length > this.maxNoOfStorages) {
        let tooMany =
            storageItemsOrderedByExpires.length - this.maxNoOfStorages;
        let deleteUs = storageItemsOrderedByExpires.splice(0, tooMany);
        for (let i = 0; i < deleteUs.length; i++) {
            this._storage.remove(deleteUs[i].key);
        }
    }
};

ItemsInViewportStorage.prototype.getItemsBySearchIds = function(searchIds) {
    let allStorageItems = this._storage.fetch();

    let storageItems = _.chain(allStorageItems)
        .filter(function(search) {
            return _.indexOf(searchIds, search.key) > -1;
        })
        .map(function(item) {
            return { searchId: item.key, items: JSON.parse(item.value).items };
        })
        .value();

    if (storageItems.length === 0) {
        return null;
    }

    return storageItems;
};

ItemsInViewportStorage.prototype.saveAllItems = function(saveUs) {
    _.each(
        saveUs,
        function(searchItem) {
            this._saveItems(searchItem.searchId, searchItem.items);
        }.bind(this)
    );
};

ItemsInViewportStorage.prototype._saveItems = function(searchId, items) {
    let currentTime = new Date().getTime();
    let expires = new Date(currentTime + this.timeToLive);

    if (items.length > this.maxNoOfItems) {
        // Make sure we're not saving more than this.maxNoOfItems
        let tooMany = items.length - this.maxNoOfItems;
        items.splice(0, tooMany);
    }

    return this._storage.set(
        searchId,
        JSON.stringify({
            items: items
        }),
        expires
    );
};

export default ItemsInViewportStorage;
